<template>
    <span class="ah-receipt-input">
        <el-input v-if="!suggestionOnly" v-model="inputVal" class="input" :disabled="disabled" :minlength="10" :maxlength="10" :show-word-limit="true"></el-input>
        <ul class="presets" v-if="presets && presets.length > 0">
            <li v-for="(p, index) in presets" :key="index" @click="onClick(p)">{{ getPrefixFormat(p) }}***</li>
        </ul>
    </span>
</template>
<script>
export default {
    name: 'ah-receipt-input',
    props: {
        value: {
            type: String,
            default: null,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        presets: {
            type: Array,
            default: () => [],
        },
        suggestionOnly: Boolean,
    },
    computed: {
        inputVal: {
            get() {
                return this.value;
            },
            set(val) {
                this.$emit('input', val.replace(/[\W]/g, '').toUpperCase());
            },
        },
    },
    methods: {
        getPrefixFormat(prefixSet) {
            const LENGTH = prefixSet.startPrefix.length;
            const returnStr = prefixSet.startPrefix.split('');
            for (let i = LENGTH; i > LENGTH - 3; i -= 1) returnStr.pop();

            return returnStr.join('');
        },
        onClick(p) {
            this.inputVal = this.getPrefixFormat(p);
        },
    },
};
</script>
<style lang="scss">
.ah-receipt-input {
    ul.presets {
        list-style: none;
        padding: 0 0 0 15px;
        margin: 0;

        > li {
            display: inline-block;
            font-size: 9.5pt;
            margin: 0 12px 0 0;
            opacity: 0.5;
            cursor: pointer;

            &:hover {
                opacity: 1;
            }
        }
    }
}
</style>
